// jQuery pSelect - pseudo select
// *disable-eslint*

/* eslint-disable */
(function ($) {
  'use strict';

  $.pSelect = function (element, options) {

    var defaults = {
      foo: 'bar',
      disabled: false,
      searchElementRegex: /^(\([0-9]+\)) (.*)/g
    };

    var plugin = this;

    plugin.settings = {};

    plugin.is_open = false;
    plugin.value = null;

    plugin.element = $(element);
    plugin.wrapper = $('.pselect-wrapper', plugin.element);
    plugin.filterController = plugin.wrapper.data('filter-controller');

    plugin.init = function () {
      plugin.settings = $.extend({}, defaults, options);
      $('.pselect-display-value', plugin.element);

      // Initialize Settings
      if (plugin.settings.disabled) {
        plugin.disable();
      }

      if (plugin.settings.default) {
        plugin.initialSelect(plugin.settings.default);
      }

      if (plugin.settings.searchElement) {
        var se = $(plugin.settings.searchElement).appendTo($('.pselect-extend', plugin.element));
        var lastValue = '';
        $('.pselect-extend input').on('autocompleteclose', function (e) {
          var regex = plugin.settings.searchElementRegex;
          var str = e.target.value;
          var m;

          while ((m = regex.exec(str)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
              regex.lastIndex++;
            }
            var nid = m[1].replace(/[()]/g, '');
            var city = m[2];
            plugin.select($('<a href="#" class="pselect-item" data-filter-type="cities" data-filter-value="' + nid + '">' + city + '</a>'));
          }
        });
      }

      // Initialize Events
      // Show select options
      $('.pselect-display-value', plugin.element).on('click', function (e) {
        e.preventDefault();
        plugin.open();
      });

      // Add Keyboard Accessibility
      // Keycodes
      var enterKeyCode = 13;
      var downArrowKeyCode = 40;
      var upArrowKeyCode = 38;
      var escapeKeyCode = 27;
      var tabKeyCode = 9;
      var tabBackKeyMap = {16: false, 9: false};
      var listItems;

      function selectFirstItem(element) {
        //Change tab order for first item in list'
        var $selectOptionsGroup = $(element).next();
        var $firstItem;
        if ($selectOptionsGroup.children('.opt-group-children').length > 0) {
          $firstItem = $selectOptionsGroup.find('.opt-group-children.active .pselect-item').first();
        }
        else {
          $firstItem = $selectOptionsGroup.find('.pselect-item').first();
        }
        $firstItem.focus();
      }

      $('.pselect-display-value', plugin.element).on('keydown', function (e) {
        if ($('.pselect-display-value', plugin.element).is(':focus')) {
          switch (e.keyCode) {
            case downArrowKeyCode:
            case enterKeyCode:
              e.preventDefault();
              $(this).closest('div').find('a.pselect-item').attr('tabindex', 0);
              selectFirstItem($(this));
              plugin.open();
              break;

          }
          return;
        }
      });

      $('.pselect-item', plugin.element).on('keydown', function (e) {
        if ($('.pselect-item', plugin.element).is(':focus')) {
          switch (e.keyCode) {
            case downArrowKeyCode:
              if ($(this).next().hasClass('pselect-opt-group')) {
                $(this).next().next().focus();
              }
              else if ($(this).next().hasClass('pselect-extend')) {
                $(this).next().find('input').focus();
              }
              else {
                $(this).next().focus();
              }
              break;

            case upArrowKeyCode:
              if ($(this).prev().hasClass('pselect-opt-group')) {
                $(this).prev().prev().focus();
              }
              else if ($(this).parent().parent().hasClass('pselect-extend')) {
                $(this).parent().parent().prev().focus();
              }
              else {
                $(this).prev().focus();
              }
              break;

            case enterKeyCode:
              if ($(this).parent().hasClass('opt-group-children')) {
                $(this).closest('.pselect-select-options').prev('.pselect-display-value').focus();
              }
              else {
                $(this).parent().prev('.pselect-display-value').focus();
              }
              $(this).trigger('click');
              $('a.pselect-item').attr('tabindex', -1);
              // plugin.close();
              break;

            case escapeKeyCode:
              if ($(this).parent().hasClass('opt-group-children')) {
                $(this).closest('.pselect-select-options').prev('.pselect-display-value').focus();
              }
              else {
                $(this).parent().prev('.pselect-display-value').focus();
              }
              plugin.close();
              $('a.pselect-item').attr('tabindex', -1);
              break;
          }
        }
      });

      // Closes dropdowns after selection is made. See VMLNATR-2972.
      $(document).ajaxComplete(function (event, xhr, settings) {
        if ($('.block-tnv-trip-planner-filters').length) {
          $('.pselect-wrapper').removeClass('active');
        }
      });

      // Line 178 interferes with trails city search box. Leaving until removal is tested.
      $('.ui-autocomplete-input', plugin.element).on('keydown', function (e) {
        if ($('.ui-autocomplete-input', plugin.element).is(':focus')) {
          switch (e.keyCode) {
            case upArrowKeyCode:
              if ($(this).parent().parent().hasClass('pselect-extend')) {
                $(this).parent().parent().prev().focus();
              }
              break;

            case tabKeyCode:
              $(this).closest('.pselect-select-options').prev().focus();
              e.preventDefault();
              break;

            case enterKeyCode:
              // $(this).closest('.pselect-select-options').prev().focus();.
              e.preventDefault();
              break;
          }
        }
      });

      // Clear selection
      $('.pselect-clear', plugin.element).on('click', function (e) {
        e.preventDefault();
        plugin.clear();
      });

      // Make selection
      $('.pselect-item', plugin.element).on('click', function (e) {
        e.preventDefault();
        plugin.select($(this));
        $('a.pselect-item').attr('tabindex', -1);
      });

      // hiding the result list when anything else except selectIt components is clicked
      $(document).click(function (event) {
        if (plugin.is_open && !$(event.target).is(plugin.element) && !$(event.target).parents().is(plugin.element)) {
          plugin.close();
          $('a.pselect-item').attr('tabindex', -1);
        }
      });
    };

    plugin.open = function () {
      plugin.is_open = true;
      plugin.wrapper.addClass('active');
      // Event handler.
      if (typeof plugin.settings.onOpen !== 'undefined') {
        plugin.settings.onOpen();
      }
    };

    plugin.close = function () {
      plugin.is_open = false;
      plugin.wrapper.removeClass('active');
      // Event handler.
      if (typeof plugin.settings.onClose !== 'undefined') {
        plugin.settings.onClose();
      }
    };

    plugin.enable = function () {
      plugin.settings.disabled = false;
      plugin.wrapper.removeClass('disabled');
      // Event handler.
      if (typeof plugin.settings.onEnable !== 'undefined') {
        plugin.settings.onEnable();
      }
    };

    plugin.disable = function () {
      plugin.settings.disabled = true;
      plugin.wrapper.addClass('disabled');
      // Event handler.
      if (typeof plugin.settings.onDisable !== 'undefined') {
        plugin.settings.onDisable();
      }
    };

    plugin.select = function (option, noCallback) {
      if (plugin.settings.disabled) {
        plugin.enable();
      }
      plugin.value = option;

      if (option !== null) {
        if (option.parent().is('.opt-group-children')) {
          plugin.showOptGroup(option.parent().data('categoryParent'));
        }

        $('.pselect-display-value', plugin.element).html(option.html());
        option.siblings().removeClass('selected');
        option.addClass('selected');
        if (plugin.settings.cascade) {
          plugin.settings.cascadeTarget.data('pSelect').parentSelect(option);
        }
        $('.pselect-clear', plugin.element).addClass('active');

        if (plugin.settings.searchElement) {
          $('.pselect-extend input', plugin.element).val('');
        }
        if (plugin.is_open) {
          plugin.close();
        }
        // Event handler.
        if (!noCallback && typeof plugin.settings.onChange !== 'undefined') {
          plugin.settings.onChange(option);
        }
      }

    };

    plugin.getValue = function () {
      return plugin.value;
    };

    plugin.initialSelect = function (value, noCallback) {
      var selected = false;
      $('.pselect-item', plugin.element).each(function () {
        if ($(this).data('filterValue') == value || $(this).html() == value) {
          plugin.select($(this), true);
          selected = true;
        }
      });
      // No matching option found so just overwrite the label and fake it.
      if (!selected) {
        $('.pselect-display-value', plugin.element).html(value);
      }
      // Event handler.
      if (!noCallback && typeof plugin.settings.onInitialSelect !== 'undefined') {
        plugin.settings.onInitialSelect(value);
      }
    };

    plugin.parentSelect = function (option) {
      if (plugin.settings.disabled) {
        plugin.enable();
      }
      if (option.data('filterValue') !== plugin.settings.optGroupId) {
        plugin.clear(true);
        plugin.hideOptGroups();
        plugin.showOptGroup(option.data('filterValue'));
      }
      // Event handler.
      if (typeof plugin.settings.onParentSelect !== 'undefined') {
        plugin.settings.onParentSelect(option);
      }
    };

    plugin.showOptGroup = function (id) {
      var optGroup = $('.opt-group-children[data-category-parent=' + id + ']', plugin.element);
      if (optGroup.length > 0) {
        optGroup.show();
        optGroup.addClass('active');
      } else {
        plugin.disable();
      }
      plugin.settings.optGroupId = id;
    };

    plugin.hideOptGroups = function () {
      $('.opt-group-children', plugin.element).hide().removeClass('active');
      plugin.settings.optGroupId = null;
    };

    plugin.clear = function (noCallback) {
      $('.pselect-clear', plugin.element).removeClass('active');
      plugin.select(null);
      $('.pselect-display-value', plugin.element).html($('.pselect-display-value', plugin.element).data('default-value'));
      $('.pselect-item', plugin.element).removeClass('selected');

      if (plugin.settings.cascade) {
        plugin.settings.cascadeTarget.data('pSelect').clear(true);
        plugin.settings.cascadeTarget.data('pSelect').hideOptGroups();
        plugin.settings.cascadeTarget.data('pSelect').disable();
      }
      // Event handler.
      if (!noCallback && typeof plugin.settings.onClear !== 'undefined') {
        plugin.settings.onClear(plugin);
      }
    };

    plugin.init();

  };

  $.fn.pSelect = function (options) {
    return this.each(function () {
        // check if there is an existing instance related to element
        var instance = $.data(this, 'pSelect');

        if (instance) {
            return instance;
        } else {
            // create the plugin
            var plugin = new $.pSelect(this, options);

            // Store the plugin instance on the element
            $.data(this, 'pSelect', plugin);
            return plugin;
        }
    });

  };

})(jQuery);
